import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  min-width: 50rem;
  max-width: 80rem;
  gap: 1.5rem;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap: 0.5rem;
`;

export const SectionTitle = styled.h3`
  display: flex;
  width: 100%;
  color: var(--darkBlue);
  font-size: 1.8rem;
  font-weight: bold;
  border-bottom: 2px solid var(--darkBlue);
  padding-bottom: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap: 0.5rem;
  font-size: 1.4rem;
  line-height: 1.6;
`;

export const Label = styled.span`
  font-weight: bold;
  color: var(--primary);
  min-width: 20rem;
`;

export const Value = styled.span`
  color: var(--black);
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  padding-left: 2rem;
  gap: 0.3rem;
`;

export const ListItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
  font-size: 1.4rem;
  color: var(--black);
  &:before {
    content: "•";
    color: var(--darkBlue);
    font-weight: bold;
    margin-right: 0.5rem;
  }
`;

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.8rem;
  width: 100%;
  padding: 1rem;
  border: 1px solid var(--primary);
  border-radius: 0.8rem;
  background-color: var(--secondary);
`;

export const SummaryItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 0.2rem;
  padding: 0.5rem;
`;

export const SummaryLabel = styled.span`
  font-weight: bold;
  font-size: 1.2rem;
  color: var(--primary);
`;

export const SummaryValue = styled.span`
  font-size: 1.6rem;
  font-weight: bold;
  color: var(--darkBlue);
`;

export const ActivityBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  padding: 1rem;
  border: 1px solid var(--primary);
  border-radius: 0.8rem;
  background-color: var(--secondary);
  gap: 0.5rem;
`;

export const ActivityName = styled.span`
  font-size: 1.5rem;
  font-weight: bold;
  color: var(--darkBlue);
  margin-bottom: 0.3rem;
`;

export const ActivityRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap: 0.5rem;
  font-size: 1.3rem;
  line-height: 1.5;
`;

export const ActivityLabel = styled.span`
  font-weight: bold;
  color: var(--primary);
  min-width: 18rem;
`;

export const ActivityValue = styled.span`
  color: var(--black);
`;

export const StatusText = styled.span`
  font-weight: bold;
  color: ${(props) => {
    switch (props.status) {
      case "registered":
        return "var(--hardGreen, green)";
      case "notDone":
        return "var(--hardRed, red)";
      case "justified":
        return "var(--hardYellow, #c7a500)";
      case "noRecord":
        return "var(--gray, #888)";
      default:
        return "var(--black)";
    }
  }};
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 2rem;
  font-size: 1.6rem;
  color: var(--primary);
`;

export const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 2rem;
  font-size: 1.6rem;
  color: var(--hardRed, red);
`;

